module.exports = __webpack_public_path__ + "static/media/AB_K2_10.5398f716.jpg";